import React, { FC, ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { themeCreator } from './base';
import { StylesProvider } from '@mui/styles';
import { GetTenant } from 'src/utils/tenant';

export const ThemeContext = React.createContext(
  (themeName: string): void => {}
);

interface CustomThemeProviderProps {
  children: ReactNode;
}

const ThemeProvider: FC<CustomThemeProviderProps> = ({ children }) => {
  const curThemeName = GetTenant().theme;
  const theme = themeCreator(curThemeName);

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export default ThemeProvider;
